import { Icon } from "components/icon/Icon";

import "./Alert.scss";

export function Alert({
  children,
  onDismiss,
  className = "",
  variant = "success",
  ...rest
}) {
  const v = variant ? `alert-${variant}` : "";
  const hasIcon = variant === "warning" || variant === "error";

  return (
    <div
      className={`alert ${v} ${className}`}
      {...rest}
    >
      {hasIcon && (
        <div className="alert-icon">
          <Icon name="exclamation-circle" size="lg" />
        </div>
      )}
      <div className="alert-content">
        {children}
      </div>
      {onDismiss && (
        <div className="alert-close">
          <Icon
            name="times cursor-pointer"
            onClick={() => onDismiss()}
          />
        </div>
      )}
    </div>
  );
}
